import HandleConvocationLogin from '@/pages/HandleConvocationLogin.vue'
import WaitingRoom from '@/pages/WaitingRoom.vue'

import Home from '@/pages/jije/Home.vue'

import auditoriums from '@/pages/jije/auditoriums/auditoriums.vue'
import showAuditorium from '@/pages/jije/auditoriums/showAuditorium.vue'
import showActivityAuditorium from '@/pages/jije/auditoriums/showActivityAuditorium.vue'

import program from '@/pages/jije/program/program.vue'
import speakers from '@/pages/jije/speakers/speakers.vue'
import juriesAndEvaluators from '@/pages/jije/juriesAndEvaluators/juriesAndEvaluators.vue'
import sponsors from '@/pages/jije/sponsors/sponsors.vue'
import participants from '@/pages/jije/participants/participants.vue'

import ProjectGallery from '@/pages/jije/projectGallery/ProjectGallery.vue'
import showProject from '@/pages/jije/projectGallery/showProject.vue'

import About from '@/pages/jije/about/About.vue'

const jijeRoutes = [
  {
    path: '/check-convocations',
    name: 'HandleConvocationLogin',
    component: HandleConvocationLogin,
    meta: {
      auth: true
    }
  },
  {
    path: '/waiting-room/:slug',
    name: 'WaitingRoom',
    component: WaitingRoom,
    meta: {
      auth: true
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        }
      ]
    }
  },
  {
    path: '/project-gallery',
    name: 'ProjectGallery',
    component: ProjectGallery,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Galeria de proyectos'
        }
      ]
    }
  },
  {
    path: '/project-gallery/:slug',
    name: 'showProject',
    component: showProject,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Galeria de proyectos',
          to: { name: 'ProjectGallery' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/speakers',
    name: 'speakers',
    component: speakers,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Speakers'
        }
      ]
    }
  },
  {
    path: '/program',
    name: 'program',
    component: program,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Programa'
        }
      ]
    }
  },
  {
    path: '/auditoriums',
    name: 'auditoriums',
    component: auditoriums,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Auditorios'
        }
      ]
    }
  },
  {
    path: '/auditoriums/:auditorium_slug',
    name: 'showAuditorium',
    component: showAuditorium,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Auditorios',
          to: { name: 'auditoriums' }
        },
        {
          text: 'Eventos'
        }
      ]
    }
  },
  
  {
    path: '/auditoriums/:auditorium_slug/event/:activity_slug',
    name: 'showActivityAuditorium',
    component: showActivityAuditorium,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Auditorios',
          to: { name: 'auditoriums' }
        },
        {
          text: 'Eventos',
          to: { name: 'showAuditorium' }
        },
        {
          text: 'Ver'
        }
      ]
    }
  },
  {
    path: '/juries-evaluators',
    name: 'juriesAndEvaluators',
    component: juriesAndEvaluators,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Jurado y Evaluadores'
        }
      ]
    }
  },
  {
    path: '/participants',
    name: 'participants',
    component: participants,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Participantes'
        }
      ]
    }
  },
  {
    path: '/sponsors',
    name: 'sponsors',
    component: sponsors,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Home',
          to: { name: 'home' }
        },
        {
          text: 'Partners'
        }
      ]
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta: {
      auth: true,
      role: 'entrepreneur', 
      breadCrumb: [
        {
          text: 'Acerca de JIJE UNL'
        }
      ]
    }
  }
]

export default jijeRoutes